import styled from 'styled-components';
import { StyledEmbeddedWidgetCon, StyledProductItemCon } from '../../../skins';

export const StyledFBTEmbeddedWidgetCon = styled(StyledEmbeddedWidgetCon)``;

export const StyledFBTProductItemCon = styled(StyledProductItemCon)`
  &.mr-product-item {
    gap: 8px;
  }
  & .mr-product-item__body {
    flex-direction: row;
  }
`;
